export default __webpack_public_path__ + "static/media/plan-add-agenda.7600614e.md";